<template>
  <div class="intent_wrapper">
    <div class="title">출제포인트 관리</div>
    <div class="searchbox">
      <b-form-radio-group
        v-model="intent_typeX"
        :options="intent_type1_field"
        class="mb-3"
        value-field="value"
        text-field="text"
        disabled-field="notEnabled"
      ></b-form-radio-group>
      <b-input v-model="srhtext" placeholder="검색키워드" />
      <div class="buttons">
        <b-button variant="primary" @click="search()" size="sm">검색</b-button>
      </div>
    </div>
    <b-alert show variant="danger">
      <ul>
        <li>출제포인트 삭제는 취소를 의미</li>
        <li>출제포인트간의 통합 및 분리는 개발자를 통해 진행</li>
      </ul>
    </b-alert>
    <b-table striped hover :fields="intent_field" :items="intents" show-empty>
      <template #empty>
        <div class="nodata">등록된 출제포인트가 없습니다</div>
      </template>
      <template #cell(사용여부)="data">
        <b-badge variant="danger" v-if="data.item.status === 1">사용중</b-badge>
      </template>

      <template #cell(관리)="data">
        <div class="buttons1">
          <b-button size="sm" variant="success" @click="write(data.item)"
            >하단생성</b-button
          >

          <b-button size="sm" variant="primary" @click="modi(data.item)"
            >수정</b-button
          >
          <b-button
            v-if="data.item.status === 0"
            size="sm"
            variant="danger"
            style="margin-left: 4px"
            @click="modi(data.item)"
            >삭제</b-button
          >
        </div>
      </template>
    </b-table>
    <XForm ref="mdlc" :item="item" />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import XForm from "@/components/intent/form";
import * as _ from "lodash";
export default {
  components: { XForm },
  mounted() {
    this.LoadIntentForAdmin();
  },
  data() {
    return {
      selected: false,
      item: {},
      srhtext: "",
    };
  },
  computed: {
    ...mapState("intentStore", ["intents", "intent_field", "intent_type"]),
    intent_type1_field() {
      return [
        { value: 1, text: "문풀훈련형" },
        { value: 2, text: "문장훈련형" },
      ];
    },
    intent_typeX: {
      set(val) {
        this.$store.commit("intentStore/updateIntentType", val);
      },
      get() {
        return this.intent_type;
      },
    },
  },
  methods: {
    ...mapActions("intentStore", [
      "LoadIntentForAdmin",
      "LoadSenIntentForAdmin",
    ]),
    write(target) {
      console.log(target.vorder);
      this.item = {
        useyn: "Y",
        target_vorder: target.vorder + 1,
      };

      this.$nextTick(() => {
        this.$bvModal.show("myid");
      });
    },
    modi(item) {
      // let k = cloneDeep(item);

      // let k = Object.freeze(item);
      // console.log(k);
      item.target_vorder = null;
      this.item = item;

      this.$nextTick(() => {
        this.$bvModal.show("myid");
      });
    },
    search() {
      if (this.intent_typeX == 1) {
        this.LoadIntentForAdmin(this.srhtext);
      } else if (this.intent_typeX == 2) {
        this.LoadSenIntentForAdmin(this.srhtext);
      }
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.intent_wrapper {
  background-color: white;
  border-radius: 5px;
  box-shadow: 3px 3px 3px $gray400;

  margin: 20px;
  padding: 20px;

  .title {
    font-size: 1.2em;
    color: $gray50;
    background-color: $gray600;
    border-radius: 4px;
    padding-bottom: 6px;
  }

  .title::before {
    content: "";
    font-size: 1.5em;
    padding-left: 6px;
    color: $gray50;
  }

  .searchbox {
    margin: 20px 0 10px 0;
  }

  .buttons {
    text-align: right;
    margin: 4px 0 4px 0;
  }

  .nodata {
    text-align: center;
    color: $point1;
  }
  .buttons1 {
    button {
      margin-right: 5px;
    }
  }
}
</style>